<template>
  <b-modal id="datauseagreement"
           size="lg"
           title="Data Use Agreement"
           class="modal-box"
           :lazy="true"
           cancel-title = "Print"
           @show="getContent"
           @cancel="print"
           no-close-on-backdrop
           no-close-on-esc>
    <div class="aggreement-content"
         v-html="content"
         v-if = "content"
         ></div>
    <m-loader v-show="!content" size="smBox"/>

  </b-modal>
</template>

<script>
    export default {
      data () {
        return {
          content: ''
        }
      },
      methods: {
        getContent () {
          this.content = false
          this.$http.post('PlaceOrder.aspx/GetDataUseAgreement', {
            listType: this.$store.state.order.ListType
          }).then(resp => {
            this.content = resp.body.d.DataSource
          })
        },
        print (evt) {
          evt.preventDefault()
          window.open(this.$store.getters['config/link']('aggrementPDF'))
        }
      }
    }
</script>

<style scoped>

  .aggreement-content {
     height: 420px;
     overflow-y:auto;
  }
</style>
<style>
  .aggreement-content pre {
    width: 100%;
    overflow: hidden;
    white-space: pre-wrap;
    padding: 16px;
    word-wrap: break-word;
    margin-bottom: 10px;
  }
  .aggreement-content pre h1{
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MDataUseAgreement.vue